export const customToFixed = (value: number, length: number): string => {
  if (!value) value = 0;
  let string = value.toFixed(length);
  if (length === 0) return string;

  // cut off all trailing zeros
  while (string.endsWith('0')) string = string.substring(0, string.length - 1);

  // cut off trailing fullstop if that is the last character
  if (string.endsWith('.')) string = string.substring(0, string.length - 1);

  return string;
};

export const customToFixedPretty = (value: number, maxLength: number): string => {
  if (!value) value = 0;
  let string = value.toFixed(2);

  if (string.includes('.')) {
    const toRemove = Math.min(Math.max(-(maxLength - (string.length - 1)), 0), 2);
    for (let index = 0; index < toRemove; index++) {
      string = string.substring(0, string.length - 1);
    }
  }

  // cut off all trailing zeros
  while (string.endsWith('0')) string = string.substring(0, string.length - 1);

  // cut off trailing fullstop if that is the last character
  if (string.endsWith('.')) string = string.substring(0, string.length - 1);

  return string;
};
